import { AuthErrorCode, LoginErrorCode, UserType } from '../../../constants/auth';
import { HttpStatus } from '../../common/types';

export type { UserType };

export type UserInfo = {
  id: number;
  email: string;
  displayName: string;
  otpVerified: boolean;
};

export type RegisteredUserInfo = {
  id: number;
  email: string;
  displayName: string;
};

// OTP Generate
export type GenerateOtpRequest = {
  phoneNumber: string;
  countryCode: string;
};

export type GenerateOtpData = {
  otpId: string;
  expiresAt: string;
  deliveryMethod: string;
};

export type GenerateOtpResponse = {
  success: boolean;
  message: string;
  data?: GenerateOtpData;
};

// OTP Verify
export type VerifyOtpRequest = {
  phoneNumber: string;
  otpCode: string;
  countryCode: string;
};

export type OtpVerificationUser = {
  userType: UserType;
  userId?: number;
  otpVerified?: boolean;
  candidateEmails?: string[];
};

export type OtpVerificationInfo = {
  user: OtpVerificationUser;
  verifiedAt: string;
};

export type VerifyOtpResponse = {
  success: boolean;
  message: string;
  otpVerificationInfo?: OtpVerificationInfo;
};

// OTP Associate (for logged-in users)
export type AssociateOtpRequest = {
  phoneNumber: string;
  otpCode: string;
};

export type AssociateOtpResponse = {
  success: boolean;
  message: string;
  userId?: number;
};

// Email Verification
export type VerifyEmailRequest = {
  phoneNumber: string;
  otpCode: string;
  selectedEmail: string;
};

export type VerifyEmailData = {
  emailVerified: boolean;
  user?: RegisteredUserInfo;
  remainingAttempts?: number;
  verifiedAt?: string;
};

export type VerifyEmailResponse = {
  success: boolean;
  message: string;
  data: VerifyEmailData;
  errorCode?: AuthErrorCode;
};

// Register
export type RegisterRequest = {
  phoneNumber: string;
  otpCode: string;
  name: string;
  email: string;
  birthday?: string;
  subscribe?: boolean;
};

export type RegisterResponse = {
  success: boolean;
  message: string;
  user?: RegisteredUserInfo;
  errorCode?: AuthErrorCode;
};

// Password Login
export type LoginRequest = {
  email: string;
  password: string;
  remember?: boolean;
};

export type LoginErrorResponse = {
  code: LoginErrorCode;
  message: string;
};

export type LoginResponse = {
  success: boolean;
  user?: UserInfo;
  error?: LoginErrorResponse;
};

// API Error Response
export type ApiErrorResponse = {
  statusCode: HttpStatus;
  errorCode: AuthErrorCode;
  message: string;
};

// Rate Limit Error Response
export type RateLimitErrorResponse = ApiErrorResponse & {
  retryAfter: number;
};

// Logout
export type LogoutResponse = {
  success: boolean;
  message: string;
};
